import React from 'react';

import ImpactStats from '../../components/ImpactStats';

import HeroBanner from '../../assets/social_projects_images/HeroBanner.jpg';

// Impact figures shown in the highlight card at the top of the page.
const impactStats = [
  { value: 10, suffix: '', label: 'Social Projects' },
  { value: 10000, suffix: '+', label: 'People Impacted' },
];
// import DetailImage1 from '../../assets/social_projects_images/TeacherProgram1.jpg';
// import DetailImage2 from '../../assets/social_projects_images/TeacherProgram2.jpg';
// import DetailImage3 from '../../assets/social_projects_images/TeacherProgram3.jpg';

function SocialProjects() {
//   const [selectedImage, setSelectedImage] = React.useState(null);

//   const detailImages = [
//     DetailImage1,
//     DetailImage2,
//     DetailImage3,
//   ];

  const benefits = [
    {
      icon: '🎓',
      title: 'สถานะ Official Certified Trainer',
      description: 'ผู้เข้าร่วมที่ผ่านเกณฑ์การ ประเมินจะได้รับการรับรองเป็น Official Certified Trainer พร้อมใบประกาศนียบัตรจาก H ACADEMY เพือยกระดับ วิชาชีพ สร้างความน่าเชือถือ และเพื่มโอกาสในสายงานการศึกษา'
    },
    {
      icon: '📚',
      title: 'คอร์สฝึกอบรมหลักสูตรการเงิน WealthyCats© WealthyClass',
      description: 'เรียนรู้วิธีการใช้บอร์ดเกม WealthyCats© ในการสอนเรื่องการเงินแบบสร้างสรรค์และสนุกสนาน เพิ่มทักษะการสื่อสาร การจัดกิจกรรม และการบริหารชุมชน'
    },
    {
      icon: '📖',
      title: 'ชุดอุปกรณ์สื่อการสอน WealthyCats©',
      description: '1.คู่มือการสอน (Trainer’s Manual)\n2.ชุดบอร์ดเกม WealthyCats©\n3.หนังสือเศรษฐีเรือนใน'
    },
    {
      icon: '🤝',
      title: 'การสนับสนุนโครงการอย่างต่อเนื่อง ',
      description: 'การให้คําปรึกษาและติดตามผลอย่างต่อเนื่องผ่านการประชุมรายเดือน \n การเข้าร่วมเครือข่าย Trainer เพื่อแลกเปลี่ยนประสบการณ์ และเสริมองค์ความรู้'
    },
    {
      icon: '📢',
      title: 'โอกาสเผยแพร่ผลงานและสร้างชื่อเสียงในสายวิชาชีพ',
      description: 'ผู้เข้าร่วมที่มีผลงานโดดเด่นจะได้รับการเผยแพร่ผลงานผ่านช่องทางของ H ACADEMY เช่น บล็อก เว็บไซต์ หรือโซเชียลมีเดีย'
    }
  ];


  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-orange-50">

      {/* Vision Hero */}
      <section className="relative h-[70vh] sm:h-[80vh] flex items-center justify-center">
        {/* Background image */}
        <img
          src={HeroBanner}
          alt="Our Vision"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center px-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
            Social Projects
          </h1>

          <p className="text-lg sm:text-xl text-gray-100 leading-relaxed">
             Empowering teachers and community leaders to deliver financial literacy education through the WealthyCats© WealthyClass board game
          </p>
        </div>
      </section>

      {/* Impact Highlights */}
      {/* Comment for now waiting for the actual numbers <ImpactStats stats={impactStats} /> */}

      {/* Hero Section */}
      <section className="relative pt-20 pb-16 md:pt-24 md:pb-20">
        <div className="absolute top-10 left-10 w-96 h-96 bg-[#FED700]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#F4900C]/20 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        
        <div className="container-custom relative z-10">
          <div className="text-center max-w-4xl mx-auto mb-8">

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              <span className="text-[#F4900C]">WealthyCats</span>: ส่งพลังการเงินสู่เยาวชนและชุมชน 
              <br />
            </h1>
            
            <p className="text-xl text-gray-600 mb-8">
                โครงการ "WealthyCats: ส่งพลังการเงินสู่เยาวชนและชุมชน" เป็น
                โอกาสสําคัญสําหรับครูและผู้นําชุมชนในการสร้างผลกระทบเชิงบวกและส่ง
                ต่อความรู ้ด้านการเงินในรูปแบบทีสนุกและสร้างแรงบันดาลใจ พร้อมท้งได้
                รับการรับรองในฐานะ Official Certified Trainer เพี่อยกระดับวิชาชีพและ
                สร้างคุณค่าอย่างยั่งยืนในชุมชนของตนเอง 
            </p>

          </div>
        </div>
      </section>

      {/* Promotion Images Gallery */}
      {/* <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              ภาพกิจกรรม<span className="text-[#F4900C]">โครงการ</span>
            </h2>
          </div>

          {detailImages.length > 0 ? (
            <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
              {detailImages.map((image, index) => (
                <div 
                  key={index}
                  onClick={() => setSelectedImage(image)}
                  className="relative rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-zoom-in"
                >
                  <img 
                    src={image}
                    alt={`รูปกิจกรรม ${index + 1}`}
                    className="w-full h-auto object-cover"
                  />
                </div>
              ))}
            </div>
          ) : (
            // Placeholder images
            <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
              {[1, 2, 3, 4].map((num) => (
                <div key={num} className="relative rounded-2xl overflow-hidden shadow-xl bg-gradient-to-br from-gray-200 to-gray-300 aspect-[4/3] flex items-center justify-center">
                  <div className="text-center">
                    <span className="text-8xl mb-4 block opacity-30">📸</span>
                    <p className="text-gray-500 font-semibold text-xl">Promotion Image {num}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section> */}

      {/* Objectives */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              วัตถุประสงค์
            </h2>
          </div>

          <div className="max-w-4xl mx-auto space-y-6">
            <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-[#F4900C]">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-r from-[#FED700] to-[#F4900C] rounded-full flex items-center justify-center text-2xl font-bold text-gray-900">
                  1
                </div>
                <p className="text-gray-700 leading-relaxed">
                  <strong>เพื่อพัฒนาศักยภาพครูและผู้นำชุมชน</strong> ให้มีความเชี่ยวชาญในการสอนหลักสูตรการเงิน WealthyCats© WealthyClass 
                  ผ่านบอร์ดเกม WealthyCats© พร้อมการรับรองสถานะ Official Certified Trainer จาก H ACADEMY 
                  เพื่อยกระดับวิชาชีพและสร้างแรงบันดาลใจ
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-[#F4900C]">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-r from-[#FED700] to-[#F4900C] rounded-full flex items-center justify-center text-2xl font-bold text-gray-900">
                  2
                </div>
                <p className="text-gray-700 leading-relaxed">
                  <strong>เพื่อเพิ่มโอกาสการเรียนรู้ทางการเงินให้เยาวชนและชุมชน</strong> โดยใช้วิธีการเรียนรู้ที่สนุกสนานมีส่วนร่วม 
                  และเหมาะสมกับบริบทในชุมชน
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-[#F4900C]">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-r from-[#FED700] to-[#F4900C] rounded-full flex items-center justify-center text-2xl font-bold text-gray-900">
                  3
                </div>
                <p className="text-gray-700 leading-relaxed">
                  <strong>เพื่อสร้างผลกระทบเชิงบวกที่จับต้องได้</strong> เช่น การเพิ่มความเข้าใจด้านการเงินของเยาวชน 
                  การพัฒนาความรับผิดชอบทางการเงินในชุมชน และการสนับสนุนให้ผู้เข้าร่วมโครงการสามารถต่อยอดความรู้
                  เพื่อสร้างการเปลี่ยนแปลงในระยะยาว
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <span className="text-[#F4900C]">สิทธิประโยชน์</span> ที่จะได้รับ
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto mb-12">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl shadow-lg p-6 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="text-5xl mb-4">{benefit.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-700 leading-relaxed whitespace-pre-line">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-[#FED700] to-[#F4900C]">
        <div className="container-custom">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              สมัครเลยวันนี้! เพื่อเป็นส่วนหนึ่งในการสร้างเด็กไทยให้เก่งคิดเรื่องการเงิน
            </h2>

            <p className="text-lg sm:text-xl font-bold text-black mb-6 drop-shadow-[0_0_15px_rgba(255,80,80,0.7)] animate-glow">
                ปิดรับสมัคร: 15 กุมภาพันธ์ 2569 <br />
                รับสมัครเพียง 5 ทุน เท่านั้น!
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
              <a
                href="https://forms.gle/s6e5WLEvy1rD7KCQ7"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-gray-900 text-white font-bold py-4 px-8 rounded-lg shadow-xl hover:bg-gray-800 transition-all duration-300 text-lg w-full sm:w-auto"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                สมัครเข้าร่วมโครงการ
              </a>

              <a
                href="/assets/social_projects/wealthycats-social-project-2.pdf"
                download
                className="inline-flex items-center gap-2 bg-white text-gray-900 font-bold py-4 px-8 rounded-lg shadow-xl hover:bg-gray-100 transition-all duration-300 text-lg w-full sm:w-auto"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                ดาวน์โหลดรายละเอียด PDF
              </a>
            </div>

          </div>
        </div>
      </section>

      {/* Image Modal */}
      {/* {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 z-10"
          >
            ×
          </button>
          <img
            src={selectedImage}
            alt="Zoomed"
            className="max-h-[90vh] max-w-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )} */}
    </div>
  );
}

export default SocialProjects;